export const ROUTE_IDS = Object.freeze({
    '/': '/',
    '/100k-terms-embedded': '/100k-terms-embedded',
    '/2024': '/2024',
    '/about-casumo': '/about-casumo',
    '/accountblocked/:token/:pid': '/accountblocked/:token/:pid',
    '/accountverification/:token/:pid': '/accountverification/:token/:pid',
    '/android-app-guide': '/android-app-guide',
    '/another-dave': '/another-dave',
    '/az-games': '/az-games',
    '/betting/cricket': '/betting/cricket',
    '/betting/cricket/big-bash': '/betting/cricket/big-bash',
    '/betting/cricket/bpl': '/betting/cricket/bpl',
    '/betting/cricket/ipl': '/betting/cricket/ipl',
    '/betting/cricket/psl': '/betting/cricket/psl',
    '/betting/cricket/t20-blast': '/betting/cricket/t20-blast',
    '/betting/football/conference-league': '/betting/football/conference-league',
    '/betting/football/europa-league': '/betting/football/europa-league',
    '/bizum-banner-test': '/bizum-banner-test',
    '/blackjack-guide': '/blackjack-guide',
    '/blackjack-guide/beginners-guide-to-understanding-the-game':
        '/blackjack-guide/beginners-guide-to-understanding-the-game',
    '/blackjack-guide/how-to-bet': '/blackjack-guide/how-to-bet',
    '/blackjack-guide/how-to-deal': '/blackjack-guide/how-to-deal',
    '/blackjack-guide/understanding-blackjack-odds':
        '/blackjack-guide/understanding-blackjack-odds',
    '/blackjack-guide/understanding-card-values': '/blackjack-guide/understanding-card-values',
    '/blackjack-guide/understanding-strategies': '/blackjack-guide/understanding-strategies',
    '/bonanza-megaways-winner': '/bonanza-megaways-winner',
    '/bonus-terms': '/bonus-terms',
    '/bonus-terms-2': '/bonus-terms-2',
    '/bonus-terms-embedded': '/bonus-terms-embedded',
    '/bonus-terms-embedded-uk': '/bonus-terms-embedded-uk',
    '/bye-kazoom-hello-casumo': '/bye-kazoom-hello-casumo',
    '/casino-games': '/casino-games',
    '/casino-games/animal-slots': '/casino-games/animal-slots',
    '/casino-games/baccarat': '/casino-games/baccarat',
    '/casino-games/beanstalk-grows-wild': '/casino-games/beanstalk-grows-wild',
    '/casino-games/best-games': '/casino-games/best-games',
    '/casino-games/blackjack': '/casino-games/blackjack',
    '/casino-games/card-games': '/casino-games/card-games',
    '/casino-games/craps': '/casino-games/craps',
    '/casino-games/crazy-coin-flip': '/casino-games/crazy-coin-flip',
    '/casino-games/dead-or-alive-saloon': '/casino-games/dead-or-alive-saloon',
    '/casino-games/egypt-slots': '/casino-games/egypt-slots',
    '/casino-games/fruit-slots': '/casino-games/fruit-slots',
    '/casino-games/gold-bar-roulette': '/casino-games/gold-bar-roulette',
    '/casino-games/jackpot-slots': '/casino-games/jackpot-slots',
    '/casino-games/lightning-roulette': '/casino-games/lightning-roulette',
    '/casino-games/lightning-roulette-extreme': '/casino-games/lightning-roulette-extreme',
    '/casino-games/megapays': '/casino-games/megapays',
    '/casino-games/megaways-slots': '/casino-games/megaways-slots',
    '/casino-games/roulette': '/casino-games/roulette',
    '/casino-games/slots': '/casino-games/slots',
    '/casino-games/slots/scatter-symbols': '/casino-games/slots/scatter-symbols',
    '/casino-games/slots/sticky-wilds': '/casino-games/slots/sticky-wilds',
    '/casino-games/the-lioness': '/casino-games/the-lioness',
    '/casino-guides': '/casino-guides',
    '/casino-guides/blackjack-strategy': '/casino-guides/blackjack-strategy',
    '/casino-guides/how-to-play-blackjack': '/casino-guides/how-to-play-blackjack',
    '/casino-guides/how-to-play-roulette': '/casino-guides/how-to-play-roulette',
    '/casino-guides/how-to-play-slingo': '/casino-guides/how-to-play-slingo',
    '/casino-guides/how-to-play-slots': '/casino-guides/how-to-play-slots',
    '/casino-guides/roulette-wheel': '/casino-guides/roulette-wheel',
    '/casino-juegos/slots/vikingos': '/casino-juegos/slots/vikingos',
    '/casino-riina': '/casino-riina',
    '/casino/slots/brand-slots': '/casino/slots/brand-slots',
    '/casinospel/slots/svenska-slots': '/casinospel/slots/svenska-slots',
    '/casinospel/spelautomater': '/casinospel/spelautomater',
    '/casumo-trivia-promo-terms': '/casumo-trivia-promo-terms',
    '/casumoverse-var': '/casumoverse-var',
    '/casumoverse-var-2': '/casumoverse-var-2',
    '/change-password/:ticketId': '/change-password/:ticketId',
    '/complaints-procedure': '/complaints-procedure',
    '/cookies-notice': '/cookies-notice',
    '/dave': '/dave',
    '/deportes-apuestas/ufc': '/deportes-apuestas/ufc',
    '/dinopolis-winner': '/dinopolis-winner',
    '/dream-cash-drop-promo-terms': '/dream-cash-drop-promo-terms',
    '/email/verify/:playerId?/:emailVerificationCode?':
        '/email/verify/:playerId?/:emailVerificationCode?',
    '/euro-2024-betting-guide': '/euro-2024-betting-guide',
    '/euro-2024-betting-guide-round-of-16': '/euro-2024-betting-guide-round-of-16',
    '/euro-2024-betting-strategies': '/euro-2024-betting-strategies',
    '/euro-2024-explained': '/euro-2024-explained',
    '/euro-2024-final-betting-guide': '/euro-2024-final-betting-guide',
    '/euro-2024-group-a-guide': '/euro-2024-group-a-guide',
    '/euro-2024-group-b-guide': '/euro-2024-group-b-guide',
    '/euro-2024-group-c-guide': '/euro-2024-group-c-guide',
    '/euro-2024-group-d-guide': '/euro-2024-group-d-guide',
    '/euro-2024-group-e-guide': '/euro-2024-group-e-guide',
    '/euro-2024-group-f-guide': '/euro-2024-group-f-guide',
    '/euro-2024-post-final-review': '/euro-2024-post-final-review',
    '/euro-2024-quarter-finals-betting-guide': '/euro-2024-quarter-finals-betting-guide',
    '/euro-2024-semi-finals-betting-guide': '/euro-2024-semi-finals-betting-guide',
    '/evolution-gaming': '/evolution-gaming',
    '/fairness-statement': '/fairness-statement',
    '/faq': '/faq',
    '/forgot-password': '/forgot-password',
    '/game-browser': '/game-browser',
    '/gameInterfaces/iframe/:encodedURL': '/gameInterfaces/iframe/:encodedURL',
    '/games/9-masks-of-fire-hyperspins': '/games/9-masks-of-fire-hyperspins',
    '/gem-drops-promo-terms': '/gem-drops-promo-terms',
    '/home': '/home',
    '/home-banner-test': '/home-banner-test',
    '/home-test': '/home-test',
    '/how-to-play/andar-bahar': '/how-to-play/andar-bahar',
    '/how-to-play/crazy-time': '/how-to-play/crazy-time',
    '/how-to-play/dragon-tiger': '/how-to-play/dragon-tiger',
    '/how-to-play/rummy': '/how-to-play/rummy',
    '/how-to-play/teen-patti': '/how-to-play/teen-patti',
    '/jackpot-blizzard-bonus-terms-embedded': '/jackpot-blizzard-bonus-terms-embedded',
    '/jackpots/casumo-jackpots': '/jackpots/casumo-jackpots',
    '/jc-pay-and-play': '/jc-pay-and-play',
    '/join': '/join',
    '/juega-blackjack-casumo-casino': '/juega-blackjack-casumo-casino',
    '/juega-ruleta': '/juega-ruleta',
    '/jumioError': '/jumioError',
    '/jumioSuccess': '/jumioSuccess',
    '/l/aff/big-bass-bonanza': '/l/aff/big-bass-bonanza',
    '/l/aff/blackjack': '/l/aff/blackjack',
    '/l/aff/blackjack-roulette': '/l/aff/blackjack-roulette',
    '/l/aff/blackjack-roulette/gentoo': '/l/aff/blackjack-roulette/gentoo',
    '/l/aff/blackjack-roulette/pick-play': '/l/aff/blackjack-roulette/pick-play',
    '/l/aff/blackjack-roulette/topcasinosuk': '/l/aff/blackjack-roulette/topcasinosuk',
    '/l/aff/book-of-dead': '/l/aff/book-of-dead',
    '/l/aff/free-to-play': '/l/aff/free-to-play',
    '/l/aff/live-casino': '/l/aff/live-casino',
    '/l/aff/live-casino/10bestcasinos': '/l/aff/live-casino/10bestcasinos',
    '/l/aff/live-casino/broidi': '/l/aff/live-casino/broidi',
    '/l/aff/live-casino/pick-play': '/l/aff/live-casino/pick-play',
    '/l/aff/live-casino/pottukoira': '/l/aff/live-casino/pottukoira',
    '/l/aff/live-casino/top-10-casinos': '/l/aff/live-casino/top-10-casinos',
    '/l/aff/live-casino/top10casinos': '/l/aff/live-casino/top10casinos',
    '/l/aff/live-casino/topcasinosuk': '/l/aff/live-casino/topcasinosuk',
    '/l/aff/slots': '/l/aff/slots',
    '/l/aff/slots/gentoo': '/l/aff/slots/gentoo',
    '/l/aff/slots/pick-play': '/l/aff/slots/pick-play',
    '/l/aff/slots/superfreeslotgames': '/l/aff/slots/superfreeslotgames',
    '/l/aff/slots/topcasinosuk': '/l/aff/slots/topcasinosuk',
    '/l/aff/sports': '/l/aff/sports',
    '/l/aff/sports-offer': '/l/aff/sports-offer',
    '/l/aff/sports/gentoo': '/l/aff/sports/gentoo',
    '/l/aff/sports/top-10-casinos': '/l/aff/sports/top-10-casinos',
    '/l/aff/top-game': '/l/aff/top-game',
    '/l/aff/top-game/10-best-casinos': '/l/aff/top-game/10-best-casinos',
    '/l/aff/top-game/pick-play': '/l/aff/top-game/pick-play',
    '/l/aff/top-game/top-casinos-uk': '/l/aff/top-game/top-casinos-uk',
    '/l/aff/welcome-offer': '/l/aff/welcome-offer',
    '/l/aff/welcome-offer/10bestcasinos': '/l/aff/welcome-offer/10bestcasinos',
    '/l/aff/welcome-offer/top-10-casinos': '/l/aff/welcome-offer/top-10-casinos',
    '/l/aff/welcome-offer/top10casinos': '/l/aff/welcome-offer/top10casinos',
    '/l/aff/welcome-offer/topcasinosuk': '/l/aff/welcome-offer/topcasinosuk',
    '/l/apuestas-deportivas': '/l/apuestas-deportivas',
    '/l/australian-open': '/l/australian-open',
    '/l/betting': '/l/betting',
    '/l/betting-site': '/l/betting-site',
    '/l/blackjack-online': '/l/blackjack-online',
    '/l/blackjack-online-b': '/l/blackjack-online-b',
    '/l/bono-de-bienvenida': '/l/bono-de-bienvenida',
    '/l/casa-de-apuestas': '/l/casa-de-apuestas',
    '/l/casino': '/l/casino',
    '/l/casino-bonus': '/l/casino-bonus',
    '/l/casino-games': '/l/casino-games',
    '/l/casino-online': '/l/casino-online',
    '/l/casino-site': '/l/casino-site',
    '/l/casino-slots': '/l/casino-slots',
    '/l/football-betting': '/l/football-betting',
    '/l/gambling-site': '/l/gambling-site',
    '/l/games/big-bass-bonanza': '/l/games/big-bass-bonanza',
    '/l/games/big-bass-splash': '/l/games/big-bass-splash',
    '/l/games/starburst': '/l/games/starburst',
    '/l/horse-racing': '/l/horse-racing',
    '/l/online-betting': '/l/online-betting',
    '/l/online-casino': '/l/online-casino',
    '/l/online-casino-b': '/l/online-casino-b',
    '/l/online-roulette': '/l/online-roulette',
    '/l/online-slots': '/l/online-slots',
    '/l/plinko': '/l/plinko',
    '/l/poker-online': '/l/poker-online',
    '/l/roulette': '/l/roulette',
    '/l/slot-games': '/l/slot-games',
    '/l/slots': '/l/slots',
    '/l/slots-b': '/l/slots-b',
    '/l/sports-betting': '/l/sports-betting',
    '/l/sports-betting-b': '/l/sports-betting-b',
    '/l/test': '/l/test',
    '/l/tj': '/l/tj',
    '/l/tragaperras-online': '/l/tragaperras-online',
    '/l/umo-days': '/l/umo-days',
    '/l/welcome-offer': '/l/welcome-offer',
    '/l/welcome-offer-b': '/l/welcome-offer-b',
    '/l/welcome-offer/briodi': '/l/welcome-offer/briodi',
    '/l/xmas-in-july': '/l/xmas-in-july',
    '/landing/adsterra': '/landing/adsterra',
    '/landing/casino-wo_b': '/landing/casino-wo_b',
    '/landing/casumo-jackpots': '/landing/casumo-jackpots',
    '/landing/prop': '/landing/prop',
    '/landing/q2-casino-wo': '/landing/q2-casino-wo',
    '/landing/q3-23-ps-book-of-dead': '/landing/q3-23-ps-book-of-dead',
    '/landing/q3-23-ps-casumo-jackpots': '/landing/q3-23-ps-casumo-jackpots',
    '/landing/q3-23-ps-mega-moolah': '/landing/q3-23-ps-mega-moolah',
    '/landing/q3-casino-wo': '/landing/q3-casino-wo',
    '/landing/roulette-q4-2023': '/landing/roulette-q4-2023',
    '/landing/slots-q4-2023': '/landing/slots-q4-2023',
    '/landing/tj': '/landing/tj',
    '/landing/welcome-offer-q4-2023': '/landing/welcome-offer-q4-2023',
    '/landing/xmas-prize-pool': '/landing/xmas-prize-pool',
    '/live-casino': '/live-casino',
    '/live-casino-welcome-offer': '/live-casino-welcome-offer',
    '/live-casino/blackjack': '/live-casino/blackjack',
    '/live-casino/casumo-studio': '/live-casino/casumo-studio',
    '/live-casino/roulette': '/live-casino/roulette',
    '/log-in': '/log-in',
    '/logged-in': '/logged-in',
    '/logged-in-out': '/logged-in-out',
    '/logged-in-slugified/:slug': '/logged-in-slugified/:slug',
    '/logged-out': '/logged-out',
    '/lp/odds': '/lp/odds',
    '/lp/slots': '/lp/slots',
    '/lucky-cards-promo-terms': '/lucky-cards-promo-terms',
    '/march-madness-2022': '/march-madness-2022',
    '/market-closure-2': '/market-closure-2',
    '/mega-fire-blaze-roulette-live-promo-terms': '/mega-fire-blaze-roulette-live-promo-terms',
    '/microgaming': '/microgaming',
    '/migration-test': '/migration-test',
    '/migration/:token/:pid': '/migration/:token/:pid',
    '/miguel-test/deposit': '/miguel-test/deposit',
    '/mobile-app': '/mobile-app',
    '/module-test-ny': '/module-test-ny',
    '/module-test-xm': '/module-test-xm',
    '/native/bankid': '/native/bankid',
    '/odds-betting/fotboll/allsvenskan': '/odds-betting/fotboll/allsvenskan',
    '/odds-betting/fotboll/vm': '/odds-betting/fotboll/vm',
    '/oddsspill/asian-handicap': '/oddsspill/asian-handicap',
    '/oddsspill/nhl': '/oddsspill/nhl',
    '/one-more-dave': '/one-more-dave',
    '/perf-test-page': '/perf-test-page',
    '/play-n-go': '/play-n-go',
    '/play-okay': '/play-okay',
    '/play/:gameSlug': '/play/:gameSlug',
    '/play/:gameSlugLocalizedEN': '/play/:gameSlugLocalizedEN',
    '/playtech': '/playtech',
    '/practice/:gameSlug': 'PRACTICE',
    '/pragmatic-10k-promo-terms': '/pragmatic-10k-promo-terms',
    '/pragmatic-play': '/pragmatic-play',
    '/privacy-notice': '/privacy-notice',
    '/privacy-notice-2': '/privacy-notice-2',
    '/promotion-terms/:promotionSlug': '/promotion-terms/:promotionSlug',
    '/promotions': 'PROMOTIONS',
    '/promotions/:promotionSlug': 'PROMOTION_DETAILS',
    '/register': '/register',
    '/relax-gaming': '/relax-gaming',
    '/removeme-dev-test': '/removeme-dev-test',
    '/restricted-territory-list': '/restricted-territory-list',
    '/retention-policy': '/retention-policy',
    '/sbc-summit-2024': '/sbc-summit-2024',
    '/schufacheck/:token/:pid': '/schufacheck/:token/:pid',
    '/select-country': '/select-country',
    '/slots': '/slots',
    '/special-promotions/astropay-bonus': '/special-promotions/astropay-bonus',
    '/special-promotions/brand-diwali': '/special-promotions/brand-diwali',
    '/special-promotions/enh-wo-slots': '/special-promotions/enh-wo-slots',
    '/special-promotions/exist-astropay-bonus': '/special-promotions/exist-astropay-bonus',
    '/special-promotions/golden-osiris': '/special-promotions/golden-osiris',
    '/special-promotions/golden-osiris-campaign': '/special-promotions/golden-osiris-campaign',
    '/special-promotions/wo-slots': '/special-promotions/wo-slots',
    '/sports-betting/american-football': '/sports-betting/american-football',
    '/sports-betting/baseball': '/sports-betting/baseball',
    '/sports-betting/boxing': '/sports-betting/boxing',
    '/sports-betting/championship': '/sports-betting/championship',
    '/sports-betting/football': '/sports-betting/football',
    '/sports-betting/football/world-cup/final-odds':
        '/sports-betting/football/world-cup/final-odds',
    '/sports-betting/football/world-cup/golden-ball-odds':
        '/sports-betting/football/world-cup/golden-ball-odds',
    '/sports-betting/football/world-cup/golden-boot-odds':
        '/sports-betting/football/world-cup/golden-boot-odds',
    '/sports-betting/football/world-cup/golden-glove-odds':
        '/sports-betting/football/world-cup/golden-glove-odds',
    '/sports-betting/football/world-cup/group-odds':
        '/sports-betting/football/world-cup/group-odds',
    '/sports-betting/football/world-cup/group-odds/group-a':
        '/sports-betting/football/world-cup/group-odds/group-a',
    '/sports-betting/football/world-cup/group-odds/group-b':
        '/sports-betting/football/world-cup/group-odds/group-b',
    '/sports-betting/football/world-cup/group-odds/group-c':
        '/sports-betting/football/world-cup/group-odds/group-c',
    '/sports-betting/football/world-cup/group-odds/group-d':
        '/sports-betting/football/world-cup/group-odds/group-d',
    '/sports-betting/football/world-cup/group-odds/group-e':
        '/sports-betting/football/world-cup/group-odds/group-e',
    '/sports-betting/football/world-cup/group-odds/group-f':
        '/sports-betting/football/world-cup/group-odds/group-f',
    '/sports-betting/football/world-cup/group-odds/group-g':
        '/sports-betting/football/world-cup/group-odds/group-g',
    '/sports-betting/football/world-cup/group-odds/group-h':
        '/sports-betting/football/world-cup/group-odds/group-h',
    '/sports-betting/football/world-cup/quarter-finals-odds':
        '/sports-betting/football/world-cup/quarter-finals-odds',
    '/sports-betting/football/world-cup/round-of-16-odds':
        '/sports-betting/football/world-cup/round-of-16-odds',
    '/sports-betting/football/world-cup/semi-final-odds':
        '/sports-betting/football/world-cup/semi-final-odds',
    '/sports-betting/football/world-cup/winner-odds':
        '/sports-betting/football/world-cup/winner-odds',
    '/sports-betting/horse-racing': '/sports-betting/horse-racing',
    '/sports-betting/ice-hockey': '/sports-betting/ice-hockey',
    '/sports-betting/march-madness': '/sports-betting/march-madness',
    '/sports-betting/odds-boost': '/sports-betting/odds-boost',
    '/sports-betting/rugby-betting': '/sports-betting/rugby-betting',
    '/sports-betting/serie-a': '/sports-betting/serie-a',
    '/sports-betting/superbowl': '/sports-betting/superbowl',
    '/sports-betting/tennis': '/sports-betting/tennis',
    '/sports-betting/virtual-sports': '/sports-betting/virtual-sports',
    '/sports-bonus-terms': '/sports-bonus-terms',
    '/sports-terms-and-conditions': '/sports-terms-and-conditions',
    '/sports-terms-and-conditions-2': '/sports-terms-and-conditions-2',
    '/sports-test': '/sports-test',
    '/sports-welcome-offer': '/sports-welcome-offer',
    '/sports-wo-test': '/sports-wo-test',
    '/sports/*': '/sports/*',
    '/sportsbet': '/sportsbet',
    '/sportsbet/baseball': '/sportsbet/baseball',
    '/sportsbet/horse-racing': '/sportsbet/horse-racing',
    '/standard-colours': '/standard-colours',
    '/template': '/template',
    '/template-tests': '/template-tests',
    '/terms-and-conditions': '/terms-and-conditions',
    '/terms-and-conditions-2': '/terms-and-conditions-2',
    '/test-new-casino': '/test-new-casino',
    '/test-sports*': '/test-sports*',
    '/testhomepage': '/testhomepage',
    '/tournament-terms-and-conditions': '/tournament-terms-and-conditions',
    '/ugliest-catch-winner': '/ugliest-catch-winner',
    '/verse': '/verse',
    '/welcome-deposit-bonus-offer-2': '/welcome-deposit-bonus-offer-2',
    '/welcome-offer': '/welcome-offer',
    '/welcome-offer-smp': '/welcome-offer-smp',
    '/withdrawal-policy': '/withdrawal-policy',
    '/wo-terms': '/wo-terms',
    '/wo-terms-embedded': '/wo-terms-embedded',
    '/yggdrasil-prize-drops-terms': '/yggdrasil-prize-drops-terms',
    ACCOUNT_VERIFICATION: '/accountverification/:token/:pid',
    ADVENTURE_PROMOPAGE: 'ADVENTURE_PROMOPAGE',
    CASH_DEPOSIT: 'CASH_DEPOSIT',
    CASH_WITHDRAW: 'CASH_WITHDRAW',
    DOCUMENTS_VERIFICATION: 'DOCUMENTS_VERIFICATION',
    FAQ: '/faq',
    GAMES: '/',
    GAMES_SEARCH: 'GAMES_SEARCH',
    GAMES_SLOTS: '/slots',
    GAMES_TOP: '/',
    HALL_OF_FAME: 'HALL_OF_FAME',
    HOME: '/',
    IDDQD: 'IDDQD',
    JACKPOTS: 'JACKPOTS',
    LIVE_CASINO: '/live-casino',
    MONTHLY_SUMMARY: 'MONTHLY_SUMMARY',
    MORE: 'MORE',
    PAYMENTS_INTERMEDIATE_REDIRECTION_CALLBACK: 'PAYMENTS_INTERMEDIATE_REDIRECTION_CALLBACK',
    PAYMENTS_PAY_AND_PLAY: 'PAYMENTS_PAY_AND_PLAY',
    PAYMENTS_REDIRECTION_CALLBACK: 'PAYMENTS_REDIRECTION_CALLBACK',
    PLAY: '/play/:gameSlug',
    PLAYER_DASHBOARD: 'PLAYER_DASHBOARD',
    PLAYER_PLAY_OKAY_SETTINGS: 'PLAYER_PLAY_OKAY_SETTINGS',
    PLAYER_SETTINGS: 'PLAYER_SETTINGS',
    PLAY_OKAY: '/play-okay',
    PRACTICE: 'PRACTICE',
    PRIVACY_POLICY: '/privacy-notice',
    PROMOTIONS: 'PROMOTIONS',
    PROMOTION_DETAILS: 'PROMOTION_DETAILS',
    REGISTER: '/register',
    RTP: 'RTP',
    SPORTS: '/sports/*',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    TOP_LISTS: '/',
    TRANSACTION_HISTORY: 'TRANSACTION_HISTORY',
    TRANSACTION_HISTORY_BETS: 'TRANSACTION_HISTORY_BETS'
});
export default ROUTE_IDS;
export type TRouteId = keyof typeof ROUTE_IDS;
